import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter, map, switchMap, startWith } from 'rxjs/operators';
import { combineLatest, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  private currentTitleKey$ = new BehaviorSubject<string>('');

  constructor(
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService
  ) {
    this.setupTitleUpdates();
  }

  private setupTitleUpdates(): void {
    const routeTitle$ = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route.snapshot.data['title'] || '';
      })
    );

    routeTitle$.subscribe(title => {
      this.currentTitleKey$.next(title);
    });

    combineLatest([
      this.currentTitleKey$.asObservable(),
      this.translateService.onLangChange.pipe(
        startWith({ lang: this.translateService.currentLang })
      )
    ]).pipe(
      filter(([titleKey]) => !!titleKey),
      switchMap(([titleKey]) => this.translateService.get(titleKey))
    ).subscribe((translatedTitle: string) => {
      this.titleService.setTitle(translatedTitle);
    });
  }

  setTitle(titleKey: string): void {
    this.currentTitleKey$.next(titleKey);
  }
}
